import ObservablePropertyDescriptorObject from '../utils/ObservablePropertyDescriptorObject';
import PropertyDescriptor from '../utils/PropertyDescriptor';

export default class DiagramRefProperty extends ObservablePropertyDescriptorObject {

    enabled = new PropertyDescriptor(false, '启用', "列", "bool", "#anticon-en_public_successful", { enabled: false });
    name = new PropertyDescriptor(``, "别名", "引用", "string", "#anticon-ui-text-field-format");
    id = new PropertyDescriptor(``, "标识", "引用", "string", "#anticon-ui-text-field-format", { enabled: false });
    // instance = new PropertyDescriptor(``, "实例", "引用", undefined, undefined, { enabled: false });

    constructor(opts = {}) {
        super();

        this.name.value = opts.name || "";
        this.id.value = opts.id || "";
        this.defineAllProperties();
    }

    toString() {
        return `${this.name || "无"} <- ${this._sys.ref && this._sys.ref.name || this.id || "无"}`;
    }
}
